import { render, staticRenderFns } from "./Wishlistuser.vue?vue&type=template&id=16c59429&"
import script from "./Wishlistuser.vue?vue&type=script&lang=js&"
export * from "./Wishlistuser.vue?vue&type=script&lang=js&"
import style0 from "./Wishlistuser.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fwishlist-user&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports